import { useMutation } from '@apollo/client';
import { UpdateProductInformationMutation, UpdateProductInformationMutationVariables } from '_graphql/mutation/__generated__/graphql';
import { UPDATE_PRODUCT_INFORMATION } from '_graphql/mutation/products';

export const useUpdateProductInformation = (
  variables?: UpdateProductInformationMutationVariables
) => {
  const [updateProductInformation, { ...rest }] = useMutation<
    UpdateProductInformationMutation,
    UpdateProductInformationMutationVariables
  >(UPDATE_PRODUCT_INFORMATION, {
    variables,
    refetchQueries: ['GetProduct'],
  });
  return {
    ...rest,
    updateProductInformation,
  };
};
